import CityPageTemplate from "../city-template/CityPageTemplate";
import { willistonConfig } from "./data";

export default function WillistonPage() {
  return <CityPageTemplate config={willistonConfig} />;
}